import styled from "styled-components";

export const StyledDCIndicatorHeaderWrapper = styled.div`
    position: absolute;
    top: 16px;
    right: 16px;
`;
